import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from '@material-ui/core';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import '../../index.css';

import request from "../../../utils/http-client";

const Data = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchData = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND}/api/get-newsletterresources`
    );
    const result = await response.json();
    if (result.result === "No newsletterresources Found") {
      setData([]);
    } else {
      setData(result);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const DeletePartnership = async (id) => {
    await request({
      method: "DELETE",
      url: `${process.env.REACT_APP_BACKEND}/api/delete-newsletterresources/${id}`,
    });
    fetchData();
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0"> Resource Newsletter</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link to="/new-resources-newsletter">
                  <Button variant="primary" size="lg">
                    Add New
                  </Button>
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-3">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.no #</TableCell>
                <TableCell>Avatar</TableCell>
                <TableCell>Url</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .slice(0)
                .reverse()
                .map((row, index) => (
                  <TableRow key={row._id}>
                    <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                    <TableCell>
                      <Link
                        to={`${process.env.REACT_APP_BACKEND}/api/download-newsletter/${row.fileId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <PictureAsPdfIcon></PictureAsPdfIcon>
                      </Link>
                    </TableCell>
                    <TableCell>
                      <b>{row.name}</b>
                    </TableCell>
                    <TableCell>
                      <DeleteTwoToneIcon
                        onClick={() => DeletePartnership(row.fileId)}
                      ></DeleteTwoToneIcon>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>
    </div>
  );
};

export default Data;
